import React, { useState } from "react"
import useApi from "../../hooks/useApi.js"

export default function StartCrawlStep({ t, shop, onStarted }) {
  const api = useApi()
  const [ submitting, setSubmitting ] = useState(false)
  const [ error, setError ] = useState(null)

  const start = async () => {
    setSubmitting(true)
    setError(null)
    try {
      await api.post("/api/v1/shop/crawl")
      onStarted()
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.onboarding.start_crawl.title")}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary leading-relaxed">
          {t("dashboard.onboarding.start_crawl.lede", { url: shop.url })}
        </p>
      </div>

      {error && <p className="text-sm text-failure">{error}</p>}

      <button
        type="button"
        onClick={start}
        disabled={submitting}
        className="bg-brand text-ink-on-dark rounded-button px-4 py-2 text-[13px] font-medium disabled:opacity-60"
      >
        {submitting
          ? t("dashboard.onboarding.start_crawl.submitting")
          : t("dashboard.onboarding.start_crawl.submit")}
      </button>
    </div>
  )
}
